/* ============================================
   EXO QUIZ ENGINE v2 — Metafield-Driven
   ============================================
   Add ONCE to your Shopify theme.
   Reads quiz configs from metaobject JSON.
   Embed is just: <div class="exo-quiz" data-quiz="handle"></div>

   Setup:
   1. Upload this file to Assets
   2. Add to theme.liquid before </body>:
      <script src="{{ 'exo-quiz.js' | asset_url }}" defer></script>
   ============================================ */

(function() {
  "use strict";

  /* ══════════════════════════════════════════
     DECLARATIVE SCORING ENGINE
     No functions needed — pure JSON rules
     ══════════════════════════════════════════ */

  // Score a result against answers using its scoring map
  // scoring: { "sensation": {"A": 2}, "visual": {"A": 2, "B": 1} }
  function scoreResult(scoring, answers) {
    var total = 0;
    for (var qid in scoring) {
      if (!scoring.hasOwnProperty(qid)) continue;
      var userAnswer = answers[qid];
      if (userAnswer && scoring[qid][userAnswer]) {
        total += scoring[qid][userAnswer];
      }
    }
    return total;
  }

  function getBestResult(results, answers) {
    var best = results[0], bestS = -1;
    for (var i = 0; i < results.length; i++) {
      var s = scoreResult(results[i].scoring || {}, answers);
      if (s > bestS) { bestS = s; best = results[i]; }
    }
    return best;
  }


  /* ══════════════════════════════════════════
     DECLARATIVE FORECAST ENGINE
     Rules format:
     {
       "base": { "redness": 2, "gym": 3, "boost": 2 },
       "rules": [
         { "when": "timing", "is": "A", "add": { "redness": 1, "gym": 1 } },
         { "when": "timing", "is": "C", "subtract": { "redness": 1 }, "min": { "redness": 1 } }
       ],
       "format": {
         "redness": "Day {v}",
         "gym": "Day {v}",
         "boost": "{v} days"
       }
     }
     ══════════════════════════════════════════ */

  function calcForecast(forecastConfig, answers) {
    if (!forecastConfig || !forecastConfig.base) return {};

    // Clone base values
    var vals = {};
    for (var k in forecastConfig.base) {
      if (forecastConfig.base.hasOwnProperty(k)) vals[k] = forecastConfig.base[k];
    }

    // Apply rules
    var rules = forecastConfig.rules || [];
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      var userAnswer = answers[rule.when];

      // Check condition
      if (rule.is && userAnswer !== rule.is) continue;
      if (rule.isNot && userAnswer === rule.isNot) continue;
      if (rule.isOneOf && rule.isOneOf.indexOf(userAnswer) === -1) continue;

      // Apply "add"
      if (rule.add) {
        for (var a in rule.add) {
          if (rule.add.hasOwnProperty(a) && vals.hasOwnProperty(a)) vals[a] += rule.add[a];
        }
      }

      // Apply "subtract"
      if (rule.subtract) {
        for (var s in rule.subtract) {
          if (rule.subtract.hasOwnProperty(s) && vals.hasOwnProperty(s)) vals[s] -= rule.subtract[s];
        }
      }

      // Apply "set"
      if (rule.set) {
        for (var st in rule.set) {
          if (rule.set.hasOwnProperty(st)) vals[st] = rule.set[st];
        }
      }

      // Apply "min" (floor values)
      if (rule.min) {
        for (var m in rule.min) {
          if (rule.min.hasOwnProperty(m) && vals.hasOwnProperty(m)) {
            vals[m] = Math.max(vals[m], rule.min[m]);
          }
        }
      }
    }

    // Format output
    var formatted = {};
    var fmt = forecastConfig.format || {};
    for (var fk in vals) {
      if (!vals.hasOwnProperty(fk)) continue;
      if (fmt[fk]) {
        formatted[fk] = fmt[fk].replace("{v}", vals[fk]);
      } else {
        formatted[fk] = String(vals[fk]);
      }
    }
    // Also include raw numeric values
    formatted._raw = vals;

    return formatted;
  }


  /* ══════════════════════════════════════════
     KLAVIYO
     ══════════════════════════════════════════ */

  function ucfirst(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function sendKlaviyo(cfg, name, email, answers, forecast, questions) {
    var pk = cfg.klaviyo_public_key;
    var lid = cfg.klaviyo_list_id;
    if (!pk) {
      console.warn("[ExoQuiz] Klaviyo not configured. Name:", name, "Email:", email);
      return Promise.resolve();
    }
    var r = getBestResult(cfg.results || [], answers);
    var props = {
      "Quiz Source": cfg.source || cfg.tag || "Quiz",
      "Quiz Result": r.id,
      "Quiz Result Title": r.title,
      "Quiz Taken Date": new Date().toISOString()
    };
    // Add answers (capitalize question ID for readable Klaviyo property names)
    for (var qi = 0; qi < (questions || []).length; qi++) {
      var q = questions[qi];
      var qLabel = ucfirst(q.id);
      props["Quiz - " + qLabel] = answers[q.id] || "";
      if (answers[q.id]) {
        for (var oi = 0; oi < q.options.length; oi++) {
          if (q.options[oi].value === answers[q.id]) {
            props["Quiz - " + qLabel + " (text)"] = q.options[oi].label;
          }
        }
      }
    }
    // Add forecast values (capitalize key for readable Klaviyo property names)
    for (var fk in forecast) {
      if (forecast.hasOwnProperty(fk) && fk !== "_raw") {
        props["Quiz - " + ucfirst(fk)] = forecast[fk];
      }
    }

    var payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: cfg.source || cfg.tag || "Quiz",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                first_name: name,
                properties: props
              }
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: lid } }
        }
      }
    };
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + pk, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
      body: JSON.stringify(payload)
    }).then(function(res) {
      if (!res.ok) console.error("[ExoQuiz] Klaviyo:", res.status);
    }).catch(function(e) { console.error("[ExoQuiz]", e); });
  }


  /* ══════════════════════════════════════════
     QUIZ INSTANCE
     ══════════════════════════════════════════ */

  function esc(str) {
    var d = document.createElement("div");
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  // Sanitize config: Shopify metaobject fields with wrong types
  // return {"error":"json not allowed..."} objects instead of strings.
  // This converts any non-string values to empty strings for text fields.
  function sanitizeConfig(cfg) {
    var textFields = ["tag","heading","subheading","source","brand","cta_text",
      "cta_url","start_button","send_button","email_title","email_description",
      "privacy_text","klaviyo_public_key","klaviyo_list_id"];
    for (var i = 0; i < textFields.length; i++) {
      var k = textFields[i];
      if (cfg[k] && typeof cfg[k] !== "string") cfg[k] = "";
    }
    // Auto-parse JSON fields that may arrive as strings
    var jsonFields = ["questions","results","forecast_cards"];
    for (var j = 0; j < jsonFields.length; j++) {
      var jk = jsonFields[j];
      if (typeof cfg[jk] === "string") {
        try { cfg[jk] = JSON.parse(cfg[jk]); } catch(e) { cfg[jk] = []; }
      }
    }
    if (typeof cfg.forecast === "string") {
      try { cfg.forecast = JSON.parse(cfg.forecast); } catch(e) { cfg.forecast = {}; }
    }
    return cfg;
  }

  function Quiz(el, cfg) {
    this.el = el;
    this.c = sanitizeConfig(cfg);
    this.id = el.id || ("eq-" + Math.random().toString(36).substr(2, 6));
    if (!el.id) el.id = this.id;
    el.classList.add("exo-quiz");
    this.questions = this.c.questions || [];
    this.results = this.c.results || [];
    this.step = 0;
    this.ans = {};
    this.userName = "";
    this.advancing = false;
    this.delay = cfg.advance_delay || 600;
    this.render();
  }

  Quiz.prototype.render = function() {
    var totalQ = this.questions.length;
    var h;
    if (this.step === 0) h = this.htmlIntro();
    else if (this.step <= totalQ) h = this.htmlQuestion(this.step - 1);
    else if (this.step === totalQ + 1) h = this.htmlEmail();
    else h = this.htmlResult();
    this.el.innerHTML = h;
    this.bind();
  };

  Quiz.prototype.forecast = function() {
    return calcForecast(this.c.forecast || {}, this.ans);
  };

  Quiz.prototype.result = function() {
    return getBestResult(this.results, this.ans);
  };

  /* ── HTML Builders ─── */

  Quiz.prototype.htmlIntro = function() {
    var c = this.c;
    return '<div class="eq-intro eq-fade">' +
      '<div class="eq-tag"><span class="eq-tag-dot"></span> ' + esc(c.tag || "QUIZ") + '</div>' +
      '<h2 class="eq-title">' + esc(c.heading || "Take the Quiz").replace(/\\n|\n/g, '<br>') + '</h2>' +
      '<p class="eq-subtitle">' + (c.subheading || "") + '</p>' +
      '<button class="eq-btn-start" data-a="start">' + esc(c.start_button || "TAKE THE 60-SECOND AUDIT") + '</button>' +
      '</div>' +
      '<div class="eq-footer">POWERED BY <strong>' + esc(c.brand || "EXOSTHETICS") + '</strong></div>';
  };

  Quiz.prototype.htmlQuestion = function(idx) {
    var q = this.questions[idx];
    var totalQ = this.questions.length;
    var sel = this.ans[q.id] || null;
    var dots = "";
    for (var i = 0; i < totalQ; i++) {
      dots += '<div class="eq-dot' + (i < idx ? ' done' : '') + (i === idx ? ' active' : '') + '"></div>';
    }
    var opts = "";
    for (var j = 0; j < q.options.length; j++) {
      var o = q.options[j];
      var letter = String.fromCharCode(65 + j);
      opts += '<button class="eq-opt' + (sel === o.value ? ' sel' : '') + '" data-a="pick" data-v="' + esc(o.value) + '" data-q="' + esc(q.id) + '">' +
        '<span class="eq-marker">' + letter + '</span><span>' + o.label + '</span></button>';
    }
    return '<div class="eq-question eq-fade">' +
      '<div class="eq-dots">' + dots + '</div>' +
      '<div class="eq-counter">QUESTION ' + (idx+1) + ' OF ' + totalQ + '</div>' +
      '<h2 class="eq-qtext">' + q.text + '</h2>' +
      '<div class="eq-opts">' + opts + '</div>' +
      (idx > 0 ? '<div class="eq-back-row"><button class="eq-back" data-a="back">\u2190 Back</button></div>' : '') +
      '</div>' +
      '<div class="eq-footer">POWERED BY <strong>' + esc(this.c.brand || "EXOSTHETICS") + '</strong></div>';
  };

  Quiz.prototype.htmlEmail = function() {
    var c = this.c;
    var f = this.forecast();
    var cards = c.forecast_cards || [];
    var preview = "";
    if (cards.length) {
      preview = '<div class="eq-sep"></div><div class="eq-preview">';
      for (var i = 0; i < cards.length; i++) {
        var fc = cards[i];
        var val = f[fc.key] || "";
        preview += '<div class="eq-pcard"><div class="eq-plabel">' + esc(fc.label) + '</div>' +
          '<div class="eq-pval">' + esc(String(val)) + '</div>' +
          (fc.suffix ? '<div class="eq-psub">' + esc(fc.suffix) + '</div>' : '') + '</div>';
      }
      preview += '</div>';
    }
    return '<div class="eq-email eq-fade">' +
      '<h2 class="eq-email-title">' + esc(c.email_title || "Your Forecast is Ready!") + '</h2>' +
      '<p class="eq-email-desc">' + (c.email_description || "Enter your email to receive your personalized results.") + '</p>' +
      '<div class="eq-form">' +
        '<input type="text" class="eq-input" id="' + this.id + '-n" placeholder="First Name" autocomplete="given-name"/>' +
        '<input type="email" class="eq-input" id="' + this.id + '-e" placeholder="Email Address" autocomplete="email"/>' +
        '<button class="eq-btn-send" data-a="submit">' + esc(c.send_button || "SEND FORECAST") + '</button>' +
      '</div>' +
      '<div class="eq-err" id="' + this.id + '-err">Please enter your name and a valid email.</div>' +
      preview +
      '<p class="eq-privacy">' + (c.privacy_text || 'We respect your privacy. Unsubscribe at any time.') + '</p>' +
      '<div class="eq-back-row" style="margin-top:1.25rem;"><button class="eq-back" data-a="back">\u2190 Back to questions</button></div>' +
      '</div>' +
      '<div class="eq-footer">POWERED BY <strong>' + esc(c.brand || "EXOSTHETICS") + '</strong></div>';
  };

  Quiz.prototype.htmlResult = function() {
    var c = this.c;
    var r = this.result();
    var f = this.forecast();
    var cards = c.forecast_cards || [];
    var greeting = this.userName ? (esc(this.userName) + ", ") : "";

    var timeline = "";
    if (cards.length) {
      timeline = '<div class="eq-timeline">';
      for (var i = 0; i < cards.length; i++) {
        var fc = cards[i];
        var val = f[fc.key] || "";
        timeline += '<div class="eq-tcard"><div class="eq-tlabel">' + esc(fc.label) + '</div>' +
          '<div class="eq-tval">' + esc(String(val)) + '</div>' +
          (fc.suffix ? '<div class="eq-tsub">' + esc(fc.suffix) + '</div>' : '') + '</div>';
      }
      timeline += '</div>';
    }

    return '<div class="eq-result eq-fade">' +
      '<div class="eq-badge ' + (r.badge_class || "eq-badge-green") + '">' + esc(r.badge || "") + '</div>' +
      '<h2 class="eq-result-heading">' + greeting + esc(r.title || "") + '</h2>' +
      timeline +
      '<div class="eq-sep"></div>' +
      '<div class="eq-result-body">' + (r.body || "") + '</div>' +
      '<div class="eq-tip">' + (r.tip || "") + '</div>' +
      '<a href="' + esc(c.cta_url || "#") + '" target="_blank" class="eq-cta">' + esc(c.cta_text || "SHOP PRODUCTS") + '</a>' +
      '<button class="eq-retake" data-a="retake">Retake quiz</button>' +
      '</div>' +
      '<div class="eq-footer">POWERED BY <strong>' + esc(c.brand || "EXOSTHETICS") + '</strong></div>';
  };

  /* ── Events (delegated) ─── */
  Quiz.prototype.bind = function() {
    var self = this;
    this.el.onclick = function(e) {
      var btn = e.target.closest("[data-a]");
      if (!btn) return;
      var action = btn.getAttribute("data-a");

      if (action === "start") { self.step = 1; self.render(); }
      else if (action === "pick") {
        if (self.advancing) return;
        self.ans[btn.getAttribute("data-q")] = btn.getAttribute("data-v");
        self.el.querySelectorAll(".eq-opt").forEach(function(b) { b.classList.remove("sel","flash"); });
        btn.classList.add("sel","flash");
        self.advancing = true;
        setTimeout(function() { self.step++; self.advancing = false; self.render(); }, self.delay);
      }
      else if (action === "back") { if (self.step > 0) { self.step--; self.render(); } }
      else if (action === "submit") { self.handleSubmit(btn); }
      else if (action === "retake") { self.step = 0; self.ans = {}; self.userName = ""; self.render(); }
    };

    // Input error clearing
    var nf = document.getElementById(this.id + "-n");
    var ef = document.getElementById(this.id + "-e");
    var clearErr = function() {
      var err = document.getElementById(self.id + "-err");
      if (err) err.style.display = "none";
      this.style.borderColor = "var(--eq-border)";
    };
    if (nf) nf.oninput = clearErr;
    if (ef) {
      ef.oninput = clearErr;
      ef.onkeydown = function(ev) {
        if (ev.key === "Enter") { var sb = self.el.querySelector('[data-a="submit"]'); if (sb) sb.click(); }
      };
    }
  };

  Quiz.prototype.handleSubmit = function(btn) {
    var nf = document.getElementById(this.id + "-n");
    var ef = document.getElementById(this.id + "-e");
    var err = document.getElementById(this.id + "-err");
    var name = nf.value.trim();
    var email = ef.value.trim();
    if (!name || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      err.style.display = "block";
      if (!name) nf.style.borderColor = "var(--eq-red)";
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) ef.style.borderColor = "var(--eq-red)";
      return;
    }
    this.userName = name;
    btn.disabled = true;
    btn.textContent = "LOADING...";
    var f = this.forecast();
    var self = this;
    sendKlaviyo(this.c, name, email, this.ans, f, this.questions).then(function() {
      self.step++;
      self.render();
    });
  };


  /* ══════════════════════════════════════════
     AUTO-INIT
     Finds all <div class="exo-quiz" data-quiz="handle">
     and initializes them from the global config
     ══════════════════════════════════════════ */

  function init() {
    // Read config from the Liquid-rendered JSON blob
    var dataEl = document.getElementById("exo-quiz-data");
    var configs = {};
    if (dataEl) {
      try { configs = JSON.parse(dataEl.textContent); }
      catch(e) { console.error("[ExoQuiz] Failed to parse config JSON:", e); }
    }

    // Find all quiz containers
    var containers = document.querySelectorAll(".exo-quiz[data-quiz]");
    containers.forEach(function(el) {
      var handle = el.getAttribute("data-quiz");
      var cfg = configs[handle];
      if (!cfg) {
        console.warn("[ExoQuiz] No config found for quiz:", handle);
        return;
      }
      new Quiz(el, cfg);
    });
  }

  // Also expose manual init for edge cases
  window.ExoQuiz = {
    init: function(containerId, config) {
      var el = document.getElementById(containerId);
      if (el) return new Quiz(el, config);
    }
  };

  // Auto-init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();